import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SKIP_GLOBAL_ERROR_TOAST } from '../helpers/http-context.tokens';

export interface S3SetupPayload {
  access_key_id: string;
  secret_access_key: string;
  bucket: string;
  region: string;
  folder: string;
}

@Injectable({
  providedIn: 'root'
})
export class S3StorageService {


  constructor(private http: HttpClient) { }

  setupS3Bucket(payload: S3SetupPayload): any {
    //   const body = {
    //   "access_key_id": "AKIATWGHULSF3WHZFA5S",
    //   "secret_access_key": "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",
    //   "bucket": "esign-v1",
    //   "region": "ap-south-1",
    //   "folder": "SecureDocs"
    // }
    return this.http.post('/s3/setup', payload, {
      context: new HttpContext().set(SKIP_GLOBAL_ERROR_TOAST, true)
    });
  }

  connectS3Bucket(): Observable<any> {
    return this.http.get(`/s3/connect`);
  }
  disconnectS3Bucket(): Observable<any> {
    return this.http.get(`/s3/disconnect`);
  }

  downloadS3Document(documentId: string): Observable<Blob> {
    return this.http.get(`/s3/download/${documentId}`, {
      responseType: 'blob'
    });
  }

  getS3Documents(paramsObj?: any) {
    let params = new HttpParams();

    if (paramsObj) {
      Object.keys(paramsObj).forEach(key => {
        const value = paramsObj[key];
        if (value !== null && value !== undefined && value !== '') {
          params = params.set(key, value);
        }
      });
    }
    return this.http.get(`/s3/documents`, { params })
  }
}
